import api from "./api";

export const getTagsAll = async (name?: string) => {
    const query = name && name !== "" ? `?name=${encodeURIComponent(name)}` : "";
    const response = await api.get(`tags/listAll${query}`);
    return response.data;
};

export const getTag = async (id: string) => {
    const response = await api.get(`tags/${id}`);
    return response.data;
};

export const postTag = async (body: any) => {
    const response = await api.post(`tags/`, body);
    return response.data;
};

export const updateTag = async (body: any, id: string) => {
    const response = await api.put(`tags/${id}`, body);
    return response.data;
};

export const deleteTag = async (id: string) => {
    const response = await api.delete(`tags/${id}`);
    return response.data;
};

export const syncTagPlants = async (id: string, idsPlants: string[]) => {
    const response = await api.put(`tags/${id}/plants`, { idsPlants });
    return response.data;
};

export const getTagsByPlant = async (plantId: string) => {
    const response = await api.get(`tags/byPlant/${plantId}`);
    return response.data;
};

export const linkTagPlant = async (tagId: string, plantId: string) => {
    const response = await api.put(`tags/${tagId}/plants/link`, { plantId });
    return response.data;
};

export const unlinkTagPlant = async (tagId: string, plantId: string) => {
    const response = await api.put(`tags/${tagId}/plants/unlink`, { plantId });
    return response.data;
};
